<template>
	<div id="app" class="auth">
		<nuxt />
	</div>
</template>

<script>
export default {
	name: 'Auth',
};
</script>

<style scoped>
.auth {
	display: flex;
	flex-direction: column;
	height: 100vh;
	width: 100%;
	align-items: center;
	justify-content: center;
}
</style>
